import 'babel-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import store from './store';
import client from './apollo-client';
import AppRoot from './app-root';
import AppRoutes from './routes/AppRoutes';

import '_styles/index.scss';

function App() {
  return (
    <DndProvider backend={HTML5Backend}>
      <ApolloProvider client={client}>
        <Provider store={store}>
          <BrowserRouter>
            <AppRoot>
              <AppRoutes />
            </AppRoot>
          </BrowserRouter>
        </Provider>
      </ApolloProvider>
    </DndProvider>
  );
}

createRoot(document.querySelector('#root')).render(<App />);
